import axios from 'axios';

export default {
  data() {
    return {
      primarySources: [
        '55 Places',
        '72Sold',
        'Absentee Owner',
        'Agent Machine',
        'Agent Pronto',
        'Agent Referral',
        'Aires',
        'Barbara Corcoran',
        'BEX',
        'Bigger Pockets',
        'Bing',
        'Bluffton Today',
        'BNI',
        'Bobby Bones',
        'Boomtown Paid Lead',
        'Brivity Paid Lead',
        'Builder',
        'Call In',
        'CINC Paid Lead',
        'Circle Prospecting',
        'Clever',
        'Cold Call',
        'Community Event',
        'Conversion Monster',
        'Craigslist',
        'Database',
        'Dave Ramsey',
        'Door Knock',
        'Driving 4 Dollars',
        'Effective Agents',
        'Expired',
        'Expired Mailer',
        'Facebook Organic',
        'Facebook Paid Ad',
        'Farming',
        'Fast Expert',
        'Firepoint Paid Lead',
        'For Sale By Owner',
        'Golden Letter',
        'GLS (Google Local Service)',
        'Google',
        'Google Paid Lead',
        'Grasshopper',
        'HomeLight',
        'Homes.com',
        'Ideal Agent',
        'Instagram',
        'Investment',
        'Just Listed/Just Sold',
        'Keller Offers Referral',
        'KW Website',
        'LHG Website',
        'LinkedIn',
        'Listing Lead',
        'Mailer',
        'Market Leader',
        'Marketing',
        'Mello Homes',
        'My Agent Finder',
        'Networking',
        'Newsletter',
        'OJO',
        'Old Team',
        'ONNIT',
        'Op City',
        'Open House',
        'Orphaned Client',
        'Phone Animal',
        'Probate',
        'Quicken Loans',
        'Radio',
        'Real Agent Pro',
        'Realtor.com',
        'Redfin',
        'Relocation',
        'Sales Center',
        'Sign Call',
        'Social Media',
        'SoldNest',
        'Sunsations',
        'Sun Today',
        'Tax List',
        'Team Lead',
        'Telemarketing',
        'TikTok',
        'Trulia',
        'Upnest',
        'Vendor Referral',
        'Walk in',
        'Website',
        'Website Lead',
        'WHHI Tapings',
        'Woodland Creek',
        'Yard Sign',
        'Yelp',
        'Ylopo',
        'Youtube',
        'ZBuyer',
        'Zillow',
        'Zillow Flex',
        'Zillow Premier'
      ],
      sources: null
    }
  },
  methods: {
    async getSources() {
      axios.get(this.userRoute + "/sources")
      .then(response => {
        this.sources = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    }
  },
  created() {
    this.getSources();
  }
}